import { useTranslation } from "react-i18next";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CancelFeedback from "@/pages/CancelFeedback";
import Onboarding from "@/pages/Onboarding";
import AppLayout from "@/pages/dashboard/AppLayout";
import Accueil from "@/pages/dashboard/Accueil";
import Caisse from "@/pages/dashboard/Caisse";
import Factures from "@/pages/dashboard/Factures";
import Banque from "@/pages/dashboard/Banque";
import { FEATURES } from "@/lib/features";
import Plus from "@/pages/dashboard/Plus";
import Admin from "@/pages/dashboard/Admin";
import BillingSuccess from "@/pages/BillingSuccess";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Processing from "@/pages/legal/Processing";
import LegalNotice from "@/pages/legal/LegalNotice";
import Contact from "@/pages/Contact";
import Reserver from "@/pages/Reserver";
import Produit from "@/pages/Produit";
import Tarifs from "@/pages/Tarifs";
import Faq from "@/pages/Faq";
import APropos from "@/pages/APropos";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import CookieConsent from "@/components/CookieConsent";
import FiduciaryView from "@/pages/FiduciaryView";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-text-secondary">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.establishment_id) return <Navigate to="/onboarding" replace />;
  return children;
}

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  const { i18n } = useTranslation();
  return (
    <div className="App" key={i18n.language}>
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <AnalyticsTracker />
          <CookieConsent />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/feedback/resiliation" element={<CancelFeedback />} />
            <Route path="/onboarding" element={<RequireAuth><Onboarding /></RequireAuth>} />
            <Route path="/billing/success" element={<RequireAuth><BillingSuccess /></RequireAuth>} />
            <Route path="/cgv" element={<Terms />} />
            <Route path="/confidentialite" element={<Privacy />} />
            <Route path="/registre-traitements" element={<Processing />} />
            <Route path="/mentions-legales" element={<LegalNotice />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/reserver" element={<Reserver />} />
            <Route path="/produit" element={<Produit />} />
            <Route path="/tarifs" element={<Tarifs />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/fiduciaire/:token" element={<FiduciaryView />} />
            <Route path="/app" element={<Protected><AppLayout /></Protected>}>
              <Route index element={<Navigate to="/app/accueil" replace />} />
              <Route path="accueil" element={<Accueil />} />
              <Route path="caisse" element={<Caisse />} />
              <Route path="factures" element={<Factures />} />
              {FEATURES.bank && <Route path="banque" element={<Banque />} />}
              <Route path="admin" element={<Admin />} />
              <Route path="plus" element={<Plus />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
